module.exports = __webpack_public_path__ + "img/unlock-keyhole-solid.d9be7987.svg";